import React from "react";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  input: {
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '& input[type=number]': {
      '-moz-appearance': 'textfield'
    },
  },
}));

const Phone = ({ input, inputId, handleInputs, value }) => {
  const classes = useStyles();

  let required = input.hasOwnProperty("yup");

  if (input.hasOwnProperty("required")) {
    required = input.required;
  }

  return (
    <TextField
      variant="standard"
      InputProps={{
        className: classes.input,
      }}
      inputProps={{
        maxLength: 20, // Allow up to 20 chars for formatting (13 digits max + spaces/dashes/parentheses)
      }}
      sx={{
        '& .MuiInput-underline:after': {
          borderBottomColor: '#004C6A',
        },
        '& .MuiInputLabel-root.Mui-focused': {
          color: '#004C6A',
          paddingTop: '4px',
        },
      }}
      type="text"
      key={inputId}
      name={inputId}
      value={value === null ? "" : value}
      required={required}
      label={input.error ? input.errorMessage : input.label}
      error={input.error}
      onChange={handleInputs}
      helperText="[country code][area code][phone number]"
    />
  );
};

export default Phone;
